export default __webpack_public_path__ + "static/media/dtmf-6.217c0ce9.mp3";